<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid persistent scrollable transition="fade-transition" max-width="600px")
    v-card
      v-card-title.px-4.h6.basic800--text
        div(v-if="option") {{ $t('update_option') }}
        div(v-else) {{ $t('add_option') }}
      v-divider.basic300
      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4(flat)
            .description
              div.label.basic600--text.text-uppercase {{$t('description.label')}}
              v-text-field.mt-3(v-model='optionData.description' dense outlined height="40" background-color="basic200" :placeholder="$t('description.placeholder')" :rules="rules.not_empty" hide-details="auto")

            .fulfilment_type
              div.mt-4.label.basic600--text.text-uppercase {{ $t('filfilment_type') }}
              v-radio-group.pa-0.mt-0.ml-n1.mt-3(v-model='optionData.fulfilment_type' row dense hide-details :rules="rules.not_empty")
                v-radio(label='Courier', value="courier")
                  template(v-slot:label)
                    div.p1.primary--text {{ $t('courier') }}
                v-radio(label='Local delivery', value="local_delivery")
                  template(v-slot:label)
                    div.p1.primary--text {{ $t('local_delivery') }}

            .service-id.mt-4(v-if="availableServices.length > 0")
              .p2 {{ $t('select_preferred_service') }}
              v-select.mt-2(v-model='optionData.preferred_shipper' placeholder="Select service" background-color="basic200" height="40" outlined dense :item-text="getShippingText" item-value="service_id" :items="availableServices" hide-details="auto")

            .charge_type
              div.mt-4.label.basic600--text.text-uppercase {{ $t('charge_type') }}
              v-radio-group.pa-0.mt-0.ml-n1.mt-3(v-model='optionData.rate_type' row dense hide-details @change="changeType(optionData.rate_type)")
                v-radio(label='Flat rate', value='flat')
                  template(v-slot:label)
                    div.p1.primary--text {{ $t('flat_rate') }}
                v-radio(label='By weight', value='weight')
                  template(v-slot:label)
                    div.p1.primary--text {{ $t('by_weight') }}
            .price
              template(v-if="optionData.rate_type === 'weight'")
                template(v-for="(param, index) in params")
                  v-row.mt-4(no-gutters align="center")
                    v-col.text-center
                      p.mb-1.label.basic600--text.text-uppercase Min
                      v-text-field(v-model='param.min_weight' outlined dense hide-details disabled type="number" suffix="kg" step="0.1")

                    v-col.px-1.pt-3.shrink
                      v-icon(x-small) mdi-tilde

                    v-col.pr-1.text-center
                      p.mb-1.label.basic600--text.text-uppercase Max
                      v-text-field(v-model='param.max_weight' dense hide-details outlined type="number" suffix="kg" step="0.01" :disabled="params.length !== index+1" :rules="rules.has_quantity")

                    v-col.pl-1.text-center
                      p.mb-1.label.basic600--text.text-uppercase {{ $t('charge') }}
                      v-text-field(v-model='param.rate' outlined dense hide-details type="number" :prefix="$currency.symbol" :placeholder="$t('price.placeholder')" :rules="rules.is_number" )

                v-row.mt-2(justify="center" no-gutters)
                  v-col.pr-1(v-if="params.length > 1")
                    v-btn(x-small dark block depressed color="danger500" @click="removeParam") {{ $t('remove_range') }}
                  v-col(:class="params.length <= 1 || 'pl-1'" )
                    v-btn.white--text(x-small block depressed color="success500" @click="addParam" :disabled="addDisabled") {{ $t('add_range') }}
              template(v-else)
                div.mt-4.label.basic600--text.text-uppercase {{$t('price.label')}}
                v-text-field.mt-3(v-model='params[0].rate' dense outlined height="40" background-color="basic200" type="number" :prefix="$currency.symbol" :placeholder="$t('price.placeholder')" :rules="rules.is_number" hide-details="auto")

            .cod(v-if="Auth('component', '/admin/settings/shipping#cash_on_delivery')")
              v-row.mt-6(no-gutters)
                v-col
                  div.p1.mb-1 {{ $t('allow_cod') }}
                  div.c1.basic600--text {{ $t('customer_can_skip_payment') }}
                v-col.shrink
                  y-switch.ma-0.pa-0(v-model="optionData.cod")
      v-card-actions.px-4
        v-btn.p2.px-0(v-if="optionData.id" color="red" text @click="showDeleteOptionDialog = true") {{ $t('delete_rate') }}
        v-spacer
        v-btn.button-AA-small(color="grey" text @click='showModal = false') {{ $t('cancel') }}
        v-btn.button-AA-small.white--text(depressed color="info500" height="32" :loading="isLoading" @click='clickSave()') {{option ? $t('update_rate') : $t('add_rate')}}
    
      .modal
        y-dialog(v-model='showDeleteOptionDialog', max-width='290')
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('delete_rate') }}
            v-card-text.p2.primary500--text.px-4 {{ $t('delete_rate_confirm_text') }}
            v-card-actions
              v-spacer
              v-btn(color='white', text @click='showDeleteOptionDialog = false')
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
                .button-AA-small.basic100--text {{ $t('delete') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'UpdateDeliveryCharge',
  props: ['open', 'company', 'option', 'zone', 'availableServices'],
  data: (v) => ({
    optionData: {
      id: null,
      description: null,
      fee: 0,
      cod: false,
      pickup: false,
      pay_at_shop: false,
      rate_type: 'flat',
      fulfilment_type: null,
      preferred_shipper: null,
      params: [],
      shipping_zone: v.zone.id
    },
    params: [
      { rate: 0 }
    ],
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0 || 'This field is required'],
      is_number: [(v) => v !== '' && v !== null || 'This field is required'],
    },
    showDeleteOptionDialog: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    addDisabled () {
      if (this.optionData.rate_type === 'weight') {
        const param = this.params[this.params.length-1]
        if (param.max_weight <= param.min_weight) {
          return true
        }
      }
      return false
    }
  },
  mounted () {
    if (this.option) {
      this.optionData = {...this.option}
      if (this.optionData.params.length > 0) {
        this.params = []
        this.optionData.params.forEach(o => {
          this.params.push({...o, rate:  (Number(o.rate)/this.$currency.multiplier)})
        })
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    addParam () {
      const max = Number(this.params[this.params.length-1].max_weight)
      this.params.push({ min_weight: parseFloat((max + 0.01).toFixed(this.$currency.exponent)), max_weight: null, rate: 0 })
    },
    removeParam () {
      this.params.pop()
    },
    changeType (func) {
      if (func === 'flat') {
        this.params = [
          { rate: 0 }
        ]
      } else if (func === 'weight') {
        this.params = [
          { min_weight: 0, max_weight: null, rate: 0 }
        ]
      }
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.addDisabled) {
        this.showMessage(['error', this.$t('error_message.please_enter_max_weight')])
        return
      }
      this.isLoading = true
      this.optionData.params = []
      this.params.forEach(o => {
        let price = o.rate || 0
        if (o.max_weight) {
          o.max_weight = parseFloat(o.max_weight)
        }
        this.optionData.params.push({ ...o, rate: Number((parseFloat(price)).toFixed(this.$currency.exponent).replace('.', '')) })
      })

      if (this.optionData.id) {
        this.$axios.put(`/shipping/settings/${this.company.slug}/manual_shippings/${this.optionData.id}/`, this.optionData)
        .then(resp => {
          this.$emit('edited', resp.data)
          this.showModal = false
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.$axios.post(`/shipping/settings/${this.company.slug}/manual_shippings/`, this.optionData)
        .then(resp => {
          this.$emit('added', resp.data)
          this.showModal = false
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    },
    startDelete() {
      this.isLoading  = true
      this.$axios.delete(`/shipping/settings/${this.company.slug}/manual_shippings/${this.option.id}/`)
        .then(() => {
          this.$emit('deleted', this.option.id)
          this.showDeleteOptionDialog = false
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading  = false
        })
    },
    getShippingText (item) {
      // console.log(item)
      return `${item.shipping_name} (${this.$options.filters.capitalize(item.service_type)})`
    },
  }
}
</script>

<style scoped>
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "add_option": "Add New Rate",
    "update_option": "Update Rate",
    "description": {
      "label": "Rate Description",
      "placeholder": "Write rate description here",
      "hint": "Example: Free Delivery, Courier Semenanjung Only, More than 10 items"
    },
    "price": {
      "label": "Charge",
      "placeholder": "0"
    },
    "update_rate": "Update Rate",
    "add_rate": "Add Rate",
    "delete_rate": "Delete Rate",
    "delete_rate_confirm_text": "Are you sure you want to delete this rate? This rate will be deleted permanently.",
    "select_preferred_service": "Select a preferred service for this rate",
    "charge_type": "Charge type",
    "flat_rate": "Flat rate",
    "by_weight": "By weight",
    "remove_range": "remove range",
    "add_range": "add range",
    "allow_cod": "Allow Cash on Delivery (COD)",
    "customer_can_skip_payment": "Customer can choose to skip payment during order submission",
    "filfilment_type": "Fulfilment type"
  },
  "id": {
     "add_option": "Tambah tarif baru",
    "update_option": "Perbarui tarif",
    "description": {
      "label": "Rincian tarif",
      "placeholder": "Tulis rincian tarif di sini",
      "hint": "Example: Tarif gratis, Tarif DKI Jakarta"
    },
    "price": {
      "label": "Tarif",
      "placeholder": "0"
    },
    "update_rate": "Perbarui tarif",
    "add_rate": "Tambah tarif",
    "delete_rate": "Hapus tarif",
    "delete_rate_confirm_text": "Anda yakin ingin menghapus tarif ini? Tarif akan dihapus secara permanen",
    "select_preferred_service": "Pilih servis yang disarankan untuk tarif ini",
    "charge_type": "Jenis Tarif",
    "flat_rate": "Tarif flat",
    "by_weight": "Berdasarkan berat",
    "remove_range": "Hapus jangkauan",
    "add_range": "tambah jangkauan",
    "allow_cod": "Ijinkan Cash on Delivery (COD)",
    "customer_can_skip_payment": "Pelanggan dapat memilih untuk melewati pembayaran selama pengiriman pesanan",
    "filfilment_type": "Jenis pengiriman"
  }
}
</i18n>
